import React from "react";

import {Class, JSTypeOperator, ObjectTypes,} from "../../../../GenericCoreGraph/ClassFramework/Class";
import LessonDetailModalStyles from "../../../../../ScriptStyles/LessonDetailModalStyles";
import TObject from "../../../../TagComponents/TObject";

import {withStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import TBaseDialogModal from "../../../Utilities/TBaseDialogModal";
import Grid from "@material-ui/core/Grid";

var TLessonSubLessonDetailsModal = Class(
  TBaseDialogModal,
  {
    ObjectType: ObjectTypes.Get("TLessonSubLessonDetailsModal"),
    constructor: function (_Props) {
      TLessonSubLessonDetailsModal.BaseObject.constructor.call(this, _Props);
      this.state = {
        ...this.state,
        open: false,
        subLessons: null,
      };
      window.App.LessonSubLessonDetailsModal = this;
    },
    Destroy: function () {
      TLessonSubLessonDetailsModal.BaseObject.Destroy.call(this);
    },
    HandleClickOpen: function (_ParamObject, _CallbackOnClose) {
      TLessonSubLessonDetailsModal.BaseObject.HandleClickOpen.call(this, _ParamObject, _CallbackOnClose);
      this.CallbackOnClose = _CallbackOnClose;
      this.setState({
        open: true,
        subLessons: _ParamObject.SubLessons
      });
    },
    HandleClose: function () {
      this.setState({
        open: false,
      });
      if (JSTypeOperator.IsFunction(this.CallbackOnClose)) {
        var __Function = this.CallbackOnClose;
        this.CallbackOnClose = null;
        __Function();
      }
    },
    HandleOnChange: function (event, _Name) {
      if (_Name) {
        this.setState({[_Name]: event.target.value});
      } else {
        this.setState({[event.target.name]: event.target.value});
      }
    },
    HandleListSubLessons: function () {
      const {classes} = this.props;
      var __This = this;
      return (
        __This.state.subLessons &&
        __This.state.subLessons.map((lesson) => {
          return (
            <Typography className={classes.professionText}>
              {__This.state.Language[lesson.Name]}
              <br/>
            </Typography>
          );
        })
      );
    },
    HandleGetSize: function () {
      return "sm";
    }
    ,
    render: function () {
      var __This = this;
      const {classes} = this.props;
      var __Params = TLessonSubLessonDetailsModal.BaseObject.render.call(this);
      if (!__Params.NeedRender) {
        return  null;
      }
      return (this.HandleWrapModal(
        <div>
            <DialogTitle
              id="customized-dialog-title"
              onClose={this.HandleInnerClose}
              className={classes.dialogTitle}
            >
              <Grid container>
                <Grid item xs={11}>
                    {__This.state.Language.SellerLessonDetail}
                </Grid>
                <Grid item xs={1}/>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>
              {this.HandleListSubLessons()}
            </DialogContent>
            <div style={{padding: "15px"}}>
              <Button
                fullWidth={true}
                autoFocus
                variant="contained"
                color="primary"
                onClick={this.HandleClose}
                className={classes.gridBorder}
              >
                {__This.state.Language.Close}
              </Button>
            </div>
        </div>)
      );
    },
  },
  {}
);

export default withStyles(LessonDetailModalStyles)(TLessonSubLessonDetailsModal);
